
import { Route, Routes, useLocation } from "react-router-dom";
import TenantHeader from "../../components/tenant/TenantHeader";
import Session from "../auth/Session";
import SignIn from "../auth/SignIn";
import SignUp from "../auth/SignUp";
import Verify from "../auth/Verify";
import OfferDetails from "../offers/OfferDetails";
import Offers from "../offers/Offers";
// import Profile from "../profile/MyCards";
import TenantTerms from "../termsandconditions/TenantTerms";
import { IdleTimerProvider } from 'react-idle-timer'
import { offerwallauthapi } from '../../config/axiosconfig';
import Cookies from "universal-cookie";


import "./offerwalllayout.css";
import TenantFooter from "../../components/tenant/TenantFooter";
import OfferSearch from "../offers/Search";
// import { Account } from "aws-sdk";
import Cashback from "../profile/cashback";
import Account from "../profile/account";
import MyCards from "../profile/MyCards";
import { useContext, useEffect } from "react";
import SpinWheel from "../gamification/SpinWheel";
import CongratulationScreen from "../gamification/CongratulationScreen";
import TermsAndConditions from "../termsandconditions/TermsAndConditions";
import ServicePolicy from "../termsandconditions/ServicePolicy";
import FAQ from "../termsandconditions/FAQ";
import { ClientContext } from "../../context/client/ClientContext";
import SharingScreen from "../gamification/SharingScreen";
import ProfileScreen from "../profile/ProfileScreen";



export default function OfferWallLayout() {


    const { pathname } = useLocation();
    const { client } = useContext(ClientContext)

    useEffect(()=>{
        document.body.addEventListener("click", ()=>{
            const nvBtn = document.getElementById("btnnavbarSupportedContentMob");
            const nvDrd = document.getElementById("navbarSupportedContentMob");
    
            nvBtn.classList.add("collapsed");
            nvDrd.classList.remove("show");
        })
    },[]);
    useEffect(() => {
        const page = document.getElementById("divPage");
        const footer = document.getElementById("divFooter");
        if (page && footer) {
            const footerHeight = footer.offsetHeight;
            const offsetTop = footer.offsetTop;
            const windowHeight = window.innerHeight;
            if (offsetTop < windowHeight - footerHeight) {
                //alert("short")
                page.style.minHeight = (windowHeight - footerHeight - page.offsetTop) + "px"
            } else {
                // alert("long")

            }
        }


        const nvBtn = document.getElementById("btnnavbarSupportedContentMob");
        const nvDrd = document.getElementById("navbarSupportedContentMob");

        nvBtn.classList.add("collapsed");
        nvDrd.classList.remove("show");


    }, [pathname]);

    const cookies = new Cookies();
    var intervalID = null;

    const intervalManager = (activate) => {
        if (activate) {
            refreshToken()
           // intervalID = setInterval(refreshToken, 1000 * 60 * 3);
        } else {
            clearInterval(intervalID);
            intervalID = null
        }
    }


    const refreshToken = async () => {
        // console.log("TRID :", typeof (cookies.get("rtid")), cookies.get("rtid"), client)
        // console.log("CLIENT", client)
        if (client && cookies.get("rtid") === true) {
            try {
                // console.log("IN REFRESH")
                const res = await offerwallauthapi.post("/api/clients/clientrefresh");
                return res.data;
            } catch (err) { }
        }
    };


    const onIdle = (event) => {
        //console.log("IDLE")
        //intervalManager(false)
    }
    const onActive = (event) => {
        //if (cookies.get("rtid")) {
        //    console.log("ACTIVE")
           // refreshToken()
        //}
    }
    const onAction = (event) => {
        //console.log("ACTION")
        refreshToken()

        //if (client && cookies.get("rtid") && !intervalID) {
        //    intervalManager(true)
        //}
    }

    return <IdleTimerProvider
        timeout={1000 * 60}
        //     onPrompt={onPrompt}
        onIdle={onIdle}
        onActive={onActive}
        onAction={onAction}
        throttle={1000 * 60 * 3 }
        //eventsThrottle={2000}
        //syncTimers={true}
        crossTab={true}>
        <>
            <TenantHeader />
            <main id="divPage">
                <Routes>
                    <Route path={"/"} element={<Offers />} />
                    <Route path={"/signup"} element={<SignUp />} />
                    <Route path={"/signin"} element={<SignIn />} />
                    <Route path={"/offerdetail/:offerid"} element={<OfferDetails />} />
                    <Route path={"/search/:searchtext"} element={<OfferSearch />} />


                    <Route path={"/gamification"} element={<SpinWheel />} />
                    <Route path={"/gamification/congratulation"} element={<CongratulationScreen />} />
                    <Route path={"/gamification/sharing"} element={<SharingScreen />} />
                    <Route path={"/terms"} element={<TermsAndConditions />} />
                    <Route path={"/servicepolicy"} element={<ServicePolicy />} />
                    <Route path={"/faq"} element={<FAQ />} />

                    {/* <Route path={"/profile"} element={<Profile />} /> */}
                    <Route path={"/user/:menuitem"} element={<ProfileScreen />} />

                    <Route path={"/verify/:verifytoken"} element={<Verify />} />
                    <Route path={"/verify/:verifytoken/:campaignid"} element={<Verify />} />
                    <Route path={"/verify/:verifytoken/ec/:emailchange"} element={<Verify />} />

                    <Route path={"/auth"} element={<Session />} />
                </Routes>
            </main>
            <footer id="divFooter">
                <TenantFooter />
            </footer>
        </>
    </IdleTimerProvider>;
}

